<template>
    <div class="shouye">
        <div class="loading" id="loadings">
      <div class="container">
        <span class="girl"></span>
        <div class="boys">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
         <!-- search -->
        <div class="dis_b">
            <div class="search_div">
                <div class="search_span">
                    <span class="qb_xxxx">全部</span>
                    <v-icon name="angle-down" class="clock"></v-icon>
                </div>
                <v-icon name="search" class="clockb"></v-icon>
                <input type="search" autocomplete="off" name="baike-search" placeholder="请输入您要搜索的内容" class="input-kw" id="input-test">
            </div>
            <span class="input_i" @click ="ss()">搜索</span>
            <div class="search_none">
                <p class="search_nep1">视频</p>
                <p class="search_nep2">音频</p>
                <p class="search_nep3">作家</p>
            </div>
            <div class="seares"></div>
            <div @click="seares()" class="searczx">换一换</div>
        </div>
       <div class="shouye-container">
          <!-- swipe -->
          <div class="dis_a">
            <mt-swipe :auto="4000">
              <mt-swipe-item v-for="(item,index) in banner" :key="index">
                  <img :src="'http://ts.winwulian.com/uploads/looppic'+'/'+item.pic" class="dis_imga">
              </mt-swipe-item>
            </mt-swipe>
          </div>
          <!-- cont -->
          <!-- 音频推荐 -->
          <p class="cnt_ppy">音频推荐</p>
          <div class="cont_home carha" id="index_border">
            <div class="cont_homea wxjz_a" v-for="item in book">
            <router-link :to="'/discover/'+item.bt_id" class="FFFFFF">{{item.bt_name}}</router-link></div>
          </div>
          <!-- 视频推荐 -->
          <p class="cnt_ppy" v-if="judge == true">视频推荐</p>
          <div class="cont_home carha" id="index_border" v-if="judge == true">
            <div class="cont_homea wxjz_a" v-for="item in video"><router-link :to="'/video/dilie/'+item.bt_id" class="FFFFFF">{{item.bt_name}}</router-link></div>
          </div>
          <!-- 最新推荐 -->
          <div class="cnt_pzx" id="recomm">
            <p class="cnt_ppzx">最新推荐</p>
            <div class="cnt_hyh">
              <v-icon name="undo" class="hyh_x"></v-icon>
              <span class="hyh_a" @click="zx">换一换</span>
            </div>
          </div>
          <div class="cont_home" id="index_border" >
            <!-- left -->
            <div class="cnt_xxa" id="cnt_axx" v-for="(item,index) in news" v-if="index<1">
              <router-link :to="'/discover/discont/'+item.b_id">
              <div class="zlmw_cnta">
                <img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic" class="img_www1">
              </div>
              <div class="cont_home stjc_cntxa">
                <div class="stjc_cntb shouye_dianxxx">
                  <span>{{item.b_bookname}}</span>
                </div>
                <div class="stjc_cntb stjc_cntbx">
                  <span>作者:<span>{{item.b_author}}</span></span>
                </div>
              </div>
             </router-link>
            </div>

            <div class="cnt_xxa" > 
              <div v-for="(item,index) in newss" v-if="index<2">
                   <router-link :to="'/discover/discont/'+item.b_id">
                    <div class="stjc_cnta">
                      <img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_wpic" class="img_www1">
                    </div>
                    <div class="cont_home stjc_cntxa">
                      <div class="stjc_cntb shouye_dianxxx">
                        <span>{{item.b_bookname}}</span>
                      </div>
                      <div class="stjc_cntb stjc_cntbx">
                        <span>作者:<span>{{item.b_author}}</span></span>
                      </div>
                    </div>
                   </router-link>
              </div>
             </div>
          </div>
          <!-- 专辑推荐 -->
          <div class="cnt_pzx">
            <p class="cnt_ppzx">专辑推荐</p>
            <div class="cnt_hyh">
              <v-icon name="undo" class="hyh_x"></v-icon>
              <span class="hyh_a" @click="zj">换一换</span>
            </div>
          </div>
          <!-- cont -->
          <div class="cont_home" id="index_border">
            <!-- left -->
            <div class="zjtj_lefthrs" v-for="(item,index) in new_tj" v-if="index<1">
             
               <router-link :to="'/discover/discont/'+item.b_id">
              <div class="zlmw_cnta" id="xxxxxxxx">
                <img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic" class="img_www1">
              </div>
              <div class="cont_home zjtj_cntxa">
                <div class="stjc_cntb shouye_dianxxx">
                  <span>{{item.b_bookname}}</span>
                </div>
                <div class="stjc_cntb zjtj_cntax">
                  <span>作者:<span>{{item.b_author}}</span></span>
                </div>
              </div>
            </router-link>
            </div>
            <!-- right -->
            <div class="zjtj_righthrs">
              <!-- top -->
              <div class="cont_home" >
                <!-- topleft -->
                <!-- <div > -->
                    <div class="zjtj_righttopa" v-for="(item,index) in new_tjs" v-if="index<2">
                       <router-link :to="'/discover/discont/'+item.b_id">
                      <div class="zjtj_righttoplefta">
                        <img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic" class="img_www1">
                      </div>
                      <p class="shouye_dianxxx">{{item.b_bookname}}</p>
                      <p class="shouye_dianxxx">作者:<span>{{item.b_author}}</span></p>
                    </router-link>
                    </div>
                    <!-- topright -->
                 <!-- toprightend -->
              </div>
              <!-- bottom -->
              <div class="cont_home">
                <!-- bottomleft -->
                <div class="zjtj_righttopa" v-for="(item,index) in new_tjss" v-if="index<2">
                   <router-link :to="'/discover/discont/'+item.b_id">
                  <div class="zjtj_righttoplefta">
                    <img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic" class="img_www1">
                  </div>
                  <p class="shouye_dianxxx">{{item.b_bookname}}</p>
                  <p class="shouye_dianxxx">作者:<span>{{item.b_author}}</span></p>
                </router-link>
                </div>
                <!-- bottomright -->
                 <!-- bottomrightend -->
              </div>
              <!-- end -->
            </div>
            <!-- right_end -->
          </div>
          <!-- 热播推荐 -->
          <div class="cnt_pzx">
            <p class="cnt_ppzx">热播推荐</p>
            <div class="cnt_hyh">
              <v-icon name="undo" class="hyh_x"></v-icon>
              <span class="hyh_a" @click="rb">换一换</span>
            </div>
          </div>
          <div class="cont_home" id="index_border">
            <!-- left -->
            <div class="cnt_xxa" id="cnt_axx" v-for="(item,index) in new_hot" v-if="index<1">
               <router-link :to="'/discover/discont/'+item.b_id">
              <div class="zlmw_cnta">
                <img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic" class="img_www1">
              </div>
              <div class="cont_home stjc_cntxa">
                <div class="stjc_cntb shouye_dianxxx">
                  <span>{{item.b_bookname}}</span>
                </div>
                <div class="stjc_cntb stjc_cntbx">
                  <span>作者:<span>{{item.b_author}}</span></span>
                </div>
              </div>
            </router-link>
            </div>
            <!-- right -->
            <div class="cnt_xxa">
              <!-- 1 -->
              <div v-for="(item,index) in new_hots" v-if="index<2">
                <router-link :to="'/discover/discont/'+item.b_id">
                  <div class="stjc_cnta">
                    <img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_wpic" class="img_www1">
                  </div>
                  <div class="cont_home stjc_cntxa">
                    <div class="stjc_cntb shouye_dianxxx">
                      <span>{{item.b_bookname}}</span>
                    </div>
                    <div class="stjc_cntb stjc_cntbx">
                      <span>作者:<span>{{item.b_author}}</span></span>
                    </div>
                  </div>
                </router-link>
              </div>
              <!-- end -->
            </div>
          </div> 
          <!-- 热门主播 -->
          <div class="cnt_pzx">
            <p class="cnt_ppzx">热门主播</p>
            <div class="cnt_hyh">
              <v-icon name="undo" class="hyh_x"></v-icon>
              <span class="hyh_a" @click="zb">换一换</span>
            </div>
          </div>
          <!-- cont -->
          <div class="cont_home" id="index_borderx">
            
            <div class="rmzb_qwe rmzb_abc" v-for="(item,index) in new_zb" v-if="index<4">
              <router-link :to="'/shouye/anchor/'+item.id">
                <img :src="'http://ts.winwulian.com/uploads/anchorphoto'+'/'+item.anc_pic" class="img_www1">
                <p class="txx_xx">{{item.anc_name}}</p>
              </router-link>
            </div>

          </div>
          <!-- 猜你喜欢 -->
          <div class="cnt_pzx">
            <p class="cnt_ppzx">猜你喜欢</p>
            <div class="cnt_hyh">
              <v-icon name="undo" class="hyh_x"></v-icon>
              <span class="hyh_a" @click="xh">换一换</span>
            </div>
          </div>
          <!-- cont -->
          <div class="cont_home " id="end_hhhh">
            
            <div class="cnxh_qwe cnxh_abc" v-for="(item,index) in new_like" v-if="index<4">
               <router-link :to="'/discover/discont/'+item.b_id">
                <img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic" class="img_www1">
                <p class="txx_xx shouye_dianxxx">{{item.b_bookname}}</p>
              </router-link>
            </div>
          </div>
          <!-- contend -->
        </div> 
        <div style="height: .6rem;width: 100%;background: #FFFFFF;"></div>
        <div class="appNav">
            <ul>
                <router-link to="/">
                <li class="home cccc">
                    <v-icon name="home" class="hv"></v-icon>
                    <p class="hp">首页</p>
                </li>
                </router-link>
                <router-link to="/discover/all">
                <li class="globe">
                    <v-icon name="globe" class="gv"></v-icon>
                    <p class="gp">专辑</p>
                </li>
                </router-link>
                <router-link to="/activity">
                <li class="comments">
                    <v-icon name="comments" class="cv"></v-icon>
                    <p class="cp">活动</p>
                </li>
                </router-link>
                <router-link to="/mine">
                <li class="user">
                    <v-icon name="user" class="uv"></v-icon>
                    <p class="up">个人</p>
                </li>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
data() {
    return {
        book:[],
        video:[],
        banner:[],
        news:[],
        newss:[],
        new_zb:[],
        new_tj:[],
        new_tjs:[],
        new_tjss:[],
        new_hot:[],
        new_hots:[],
        new_like:[],
        search: [],
        j: 3,
        judge : true,
    }
},
updated() {

},
created(){
    this.getAjax();
    // this.gettuijains();
    // this.gethots();
    setTimeout(function(){
    $('.loading').remove()
  },1500)
},
mounted() {
    // setTimeout(function(){
    //   $('.loading').remove()
    // },1000)
//Y
    // var y = $(window).height();
    // console.log('当前可视'+y)
    // $(window).scroll(function(){
    //     var zy = y + $(document).scrollTop(); 
    //     console.log("滚动后"+zy)
    //     if(y < zy){
    //     }
    // });
    // var recomm =  $("#recomm").offset().top - $(window).scrollTop();
    // console.log(recomm)
// 获取openid ojB_qwzG8iUCtynfWZrdpfqsA5wc
    var i=0;
    var _href=window.location.href
    this._sef = _href.split("=")
    if ( this._sef[1] == '' || this._sef[1] == undefined || this._sef[1] == null || this._sef[1] == NaN) {
        if (localStorage.getItem("openid")) {
            var openid=localStorage.getItem("openid");
        }else{
            console.log("666")
        }
    }else{
        var openid=this._sef[1];
        localStorage.setItem("openid",openid);
    }
//     localStorage.setItem("openid","ojB_qw08q0gTspwjriYI3OxqsGeQ");
// search
    $('.search_span').click(function(){
        i++;
        var j =i % 2
        if(j == 0){
            $('.search_none').fadeOut()
        }else{
            $('.search_none').fadeIn()
        }
        $('.search_nep1').click(function(){
            var search_nep1=$('.search_nep1').text()
            $('.search_none').fadeOut()
            $('.qb_xxxx').text(search_nep1)
        });
        $('.search_nep2').click(function(){
            var search_nep2=$('.search_nep2').text()
            $('.search_none').fadeOut()
            $('.qb_xxxx').text(search_nep2)
        });
        $('.search_nep3').click(function(){
            var search_nep3=$('.search_nep3').text()
            $('.search_none').fadeOut()
            $('.qb_xxxx').text(search_nep3)
        });
    })
    Object.assign(this.$data, this.$options.data())
},
methods:{
    getAjax:function () {
    	var that = this
     var successCallback =  (response) => {
        var seares = $('.seares')
        var js = []
        if(response){
            // 音频推荐
            this.book = response.booktypelist
            // 视频推荐
            this.video = response.booktypelist_yin
            if(this.video.length == 0){
                this.judge = false;
            }
            // 轮播图
            this.banner = response.looppic
            // 热搜
            this.search = response.keyword
            //最新推荐
            this.news = response.booktypelist_new
            this.newss = response.booktypelist_news
            // 专辑推荐
            this.new_tj = response.booktypelist_tj
            this.new_tjs = response.booktypelist_tjs
            this.new_tjss = response.booktypelist_tjss
            //热播推荐
            this.new_hot = response.booktypelist_hot
            this.new_hots = response.booktypelist_hots
            // 热门主播
            this.new_zb = response.booktypelist_zb
            //猜你喜欢
            this.new_like = response.booktypelist_like
            
            if(this.search.length < 3){
                for(var i=0;i<this.search.length;i++){
                    js[i] = '<span style="display:inline-block;color:#FFFFFF;margin-right:15px;" class="searkey" id="'+i+'">'+this.search[i].keyword+'</span>';
                }
            }else{
                for(var i=0;i<3;i++){
                    js[i] = '<span style="display:inline-block;color:#FFFFFF;margin-right:15px;" class="searkey" id="'+i+'">'+this.search[i].keyword+'</span>';
                }
            }
            seares.append(js)
            $('.searkey').click(function(){
                var id = this.id
                var i = Number(id)
                var text= response.keyword[i].keyword
                localStorage.setItem("fonts",text);
//              location.href = '/shouye/sous';
                that.$router.replace({path: '/shouye/sous'});
            })
        }
      }
      var errorCallback =  (response) => {
          console.log('服务器请求出错了')
      }
      this.$http.get(CURL+'/portal/All/getydz').then(successCallback,errorCallback);
    },
    // gettuijains () {
    //   var success =  (data) => {
    //     console.log('success')
    //     //最新推荐
    //     this.news = data.booktypelist_new
    //     this.newss = data.booktypelist_news
    //     // 专辑推荐
    //     this.new_tj = data.booktypelist_tj
    //     this.new_tjs = data.booktypelist_tjs
    //     this.new_tjss = data.booktypelist_tjss
    //   }
    //   var error =  (data) => {
    //     console.log('error')
    //   }
    //   this.$http.get(CURL+'/portal/All/gettuijains').then(success,error);
    // },
    // gethots () {
    //   var success =  (data) => {
    //     console.log('success')
    //     //热播推荐
    //     this.new_hot = data.booktypelist_hot
    //     this.new_hots = data.booktypelist_hots
    //     // 热门主播
    //     this.new_zb = data.booktypelist_zb
    //     //猜你喜欢
    //     this.new_like = data.booktypelist_like
    //   }
    //   var error =  (data) => {
    //     console.log('error')
    //   }
    //   this.$http.get(CURL+'/portal/All/gethots').then(success,error);
    // },
    seares () {
        var seares = $('.seares')
        seares.empty()
        var that = this;
        var js = []
        var s = this.search.length - this.j
        console.log(s)
        if(s > 0 && s < 3){
            for(var i = this.j;i < this.search.length;i++){
                js[i] = '<span style="display:inline-block;color:#FFFFFF;margin-right:15px;" class="searkey" id="'+i+'">'+this.search[i].keyword+'</span>'
            }
            this.j+=3
        }else if(s >= 3){
            for(var i = this.j;i < this.j+3;i++){
                js[i] = '<span style="display:inline-block;color:#FFFFFF;margin-right:15px;" class="searkey" id="'+i+'">'+this.search[i].keyword+'</span>'
            }
            this.j+=3
        }else if(s < 0){
            this.j = 0
            for(var i = this.j;i < 3;i++){
                js[i] = '<span style="display:inline-block;color:#FFFFFF;margin-right:15px;" class="searkey" id="'+i+'">'+this.search[i].keyword+'</span>'
            }
            this.j+=3
        }
        seares.append(js)
        var a = this.search
        $('.searkey').click(function(){
                var id = this.id
                var i = Number(id)
                var text= a[i].keyword
                localStorage.setItem("fonts",text);
//              location.href = '/shouye/sous';
                that.$router.replace({path: '/shouye/sous'});
            })
    },
    zx:function(){
      this.news.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
      this.newss.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});

    },
    zj:function(){
      this.new_tj.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
      this.new_tjs.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
      this.new_tjss.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
    },
    rb:function(){
      this.new_hot.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
      this.new_hots.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
    },
    zb:function(){
      this.new_zb.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
    },
    xh:function(){
      this.new_like.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
    },
    ss:function(){
      var str = $('#input-test').val();
      if(str == '' || str == null || str == undefined || str == NaN){
        console.log("傻子")
      }else{
        localStorage.setItem("fonts",str);
//      location.href = '/shouye/sous';
        this.$router.replace({path: '/shouye/sous'});
      }
    }
   
  }
}
</script>

<style lang="scss" scoped>

/*tap*/
.appNav {
  width: 100%;
  height: 0.6rem;
  border-top: 0.01rem solid #f2f2f2;
  background: #ffffff;
  position: fixed;
  bottom:0;
  ul,
  li{
    list-style: none;
  }
  ul{
    li{
        float: left;
        width: 25%;
        text-align: center;
    }
  }
}
.hv,.gv,.cv,.uv{
  margin-top: .13rem;
}
.cccc{
  color: #4eb1d3!important;
}
/*tap*/


/**/
.searczx{
    padding: 5px 0;
    float: right;
    width: 14%;
    color: #F0FFF0;
    font-weight: 600;
    font-size: 14px;
}
.seares{
    padding: 5px 0 5px 10%;
    float: left;
    text-align: center;
    width: 86%;
    overflow: hidden;
    height: 26px;
}
/*loading*/
.container {
    margin-top: 50%;
    margin-left:18%; 
    width: 55%;
    height: 1em;
    font-size: 35px;
    display: flex;
    justify-content: space-between;
}

.container span {
    width: 15px;
    height: 15px;
    --duration: 1.5s;
}

.girl {
    animation: slide var(--duration) ease-in-out infinite alternate;
}

@keyframes slide {
    from {
        transform: translateX(0);
        filter: brightness(1);
    }

    to {
        transform: translatex(calc(8em - (1em * 1.25)));
        filter: brightness(1.45);
    }
}

.boys {
    width: 65%;
    display: flex;
    justify-content: space-between;
}

.boys span {
    animation: var(--duration) ease-in-out infinite alternate;
}

.boys span:nth-child(1) {
    animation-name: jump-off-1;
}

.boys span:nth-child(2) {
    animation-name: jump-off-2;
}

.boys span:nth-child(3) {
    animation-name: jump-off-3;
}

.boys span:nth-child(4) {
    animation-name: jump-off-4;
}

@keyframes jump-off-1 {
    0%, 15% {
        transform: rotate(0deg);
    }

    35%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-2 {
    0%, 30% {
        transform: rotate(0deg);
    }

    50%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-3 {
    0%, 45% {
        transform: rotate(0deg);
    }

    65%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-4 {
    0%, 60% {
        transform: rotate(0deg);
    }

    80%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

.container span::before {    
    content: '';
    position: absolute;
    width: inherit;
    height: inherit;
    border-radius: 15%;
    box-shadow: 0 0 0.1em rgba(0, 0, 0, 0.3);
}

.girl::before {
    background-color: #7988da;
}

.boys span::before {
    background-color: dodgerblue;
    animation: var(--duration) ease-in-out infinite alternate;
}

.boys span:nth-child(1)::before {
    filter: brightness(1);
    animation-name: jump-down-1;
}

.boys span:nth-child(2)::before {
    filter: brightness(1.15);
    animation-name: jump-down-2;
}

.boys span:nth-child(3)::before {
    filter: brightness(1.3);
    animation-name: jump-down-3;
}

.boys span:nth-child(4)::before {
    filter: brightness(1.45);
    animation-name: jump-down-4;
}

@keyframes jump-down-1 {
    5% {
        transform: scale(1, 1);
    }

    15% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    20%, 25% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    40% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    55%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-2 {
    20% {
        transform: scale(1, 1);
    }

    30% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    35%, 40% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    55% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    70%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-3 {
    35% {
        transform: scale(1, 1);
    }

    45% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    50%, 55% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    70% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    85%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-4 {
    50% {
        transform: scale(1, 1);
    }

    60% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    65%, 70% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    85% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    100%, 100% {
        transform: scale(1, 1);
    }
}

.loading{
  background-color:#00a8d9;
  position:fixed;
  z-index:999999;
  top:0;
  left:0;
  width:100%;
  height:100%;
  text-align:center;
  line-height:300px;
  padding-top: 35%;
  padding-left: 5%;
  padding-right: 5%;
}
/**/
#xxxxxxxx{
  height: 241px;
}
#index_borderx{
  padding-bottom: 29px;
  border-bottom: #eee solid 1px;
}
#end_hhhh{
  margin-bottom: .25rem;
}
.txx_xx{
  margin-top: 5px;
  text-align: center;
  height: 18px;
}
.img_www1{
  width: 100%;
}
/**/
.search_nep3{
  margin-top: 20px;
  margin-bottom: 20px;
}
.search_nep1{
  margin-top: 15px;
  margin-bottom: 18px;
}
.search_none{
  display: none;
  position: fixed;
  background-color: #FFFFFF;
  top: 37px;
  left: 5%;
  border-radius: 5px;
  p{
    padding-left: 8px;
    padding-right: 23px;
    font-size: 13px;
    color: #333;
  }
}
.FFFFFF{
  color: #FFFFFF;
}
/*cont*/
/*猜你喜欢*/
.cnxh_abc{
  margin-left: 2%;
}
.cnxh_qwe{
  width: 22.5%;
  height: 130px;
  /*background-color: #60b5d8;*/
}
/*热门主播*/
.rmzb_abc{
  margin-left: 2%;
}
.rmzb_qwe{
  margin-right: 2%;
  width: 22.5%;
  height: 80px;
  /*background-color: #60b5d8;*/
}
/*热播推荐*/

/*专辑推荐*/
.zjtj_righttoplefta,.zjtj_righttopleftb{
  width: 100%;
  /*background-color: #60b5d8;*/
  height: 100px;
}
.zjtj_righttopa,.zjtj_righttopb{
  width: 48%;
    p{
    height: 18px;
  }
}
.zjtj_righttopa{
  margin-right: 4%;
}
.zjtj_cntax{
  text-align: right;
  overflow: hidden;
}
.zjtj_cntxa{
  height: 25px;
  line-height: 25px;
  overflow: hidden;
}
.zjtj_lefthrs{
  width: 46%;
  margin-left: 3%;
  margin-right: 2%;
}
.zjtj_righthrs{
  width: 46%;
  margin-right: 3%;
}
/*最新推荐*/
#cnt_axx{
  margin-left: 3%;
  margin-right: 2%;
}
.stjc_cntxa{
  height: 25px;
  line-height: 25px;
  overflow: hidden;
}
.stjc_cntbx{
  text-align: right;
  overflow: hidden;
}
.stjc_cntb{
  width: 50%;
  overflow: hidden;
}
.stjc_cnta,.hbgs_cnta{
  width: 100%;
  height: 90px;
  /*background-color: #60b5d8;*/
}
.cnt_xxa{
  width: 46%;
  height: auto;
  margin-right: 3%;
}
.zlmw_cnta{
  width: 100%;
  height: 205px;
 /* background-color: #00a8d9;*/
}
.hyh_x{
  margin-top: 13px;
  margin-bottom: -3px;
  color: #777;
  width: 12px;
}
.hyh_a{
  color: #777;
  width: 31%;
}
.cnt_hyh{
  width: 37%;
  text-align: right;
  margin-right: 3%;
}
.cnt_pzx{
  width: 100%;
  display: flex;
  display: -webkit-flex;
  direction: row;
}
.cnt_ppzx{
  padding: 10px 0 10px 2.5%;
  font-size: 16px;
  color: #333;
  width: 60%;
}
/*音频*/
.cnt_ppy{
  padding: 10px 0 10px 2.5%;
  font-size: 16px;
  color: #333;
}
.cont_home{
  width: 100%;
  display: flex;
  display: -webkit-flex;
  direction: row;
  padding-bottom: 5px;
}
.cont_homea{
  width: 30%;
  background:url(../../img/bj.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #FFFFFF;
  border-radius: 2px;
  margin-top: 5px;
}
.carha{
  flex-wrap:wrap;
}
.wxjz_a{
  margin-left: 2.5%;
}
.ctwh_a{
   margin-left: 2.5%;
}
.mjjt_a{
  margin-left: 2.5%;
  margin-right: 2.5%;
}
/*视频*/

/*全局*/
.shouye_dianxxx{
  overflow: hidden;
  white-space:nowrap;
  -webkit-text-overflow:ellipsis;
  -moz-text-overflow:ellipsis;
  -o-text-overflow:ellipsis;
  -ms-text-overflow:ellipsis;
  text-overflow:ellipsis;
}
.shouye {
  display: flex;
  flex-direction: column;
  margin-bottom: .6rem;
}
#index_border{
  padding-bottom: 8px;
  border-bottom: #eee solid 1px;
}
.shouye-container {
  flex: 1;
  margin-top: .63rem;
}
/*search*/
.dis_b{
  z-index: 999;
  position: fixed;
  width: 100%;
  background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;

}

.search_div{
  height: 33px;
  width: 80%;
  background-color: #FFFFFF;
  float: left;
  margin-left: 5%;
  border-radius: 8px;
  margin-top: 11px;
  line-height: 36px;
}
.input-kw{
  margin-bottom: 8px;
  width: 65%;
  background-color: transparent;
  border:0;
}
.input_i{
  color: #FFFFFF;
  font-size: 16px;
  float: left;
  margin-top: 16px;
  margin-left: 5px;
}
.search_span{
  width: 17%;
  height: 30px;
  float: left;
  margin-left: 3%;
  background-color: #FFFFFF;
  border-right: #ccc solid 1px;
  padding-right: 5px;
  color: #87ceeb;
  font-size: 14px;
}
#input-test::-webkit-input-placeholder{
  font-size: 12px;
  color: #999;
}
.clockb{
  color: #999;
  margin-top: 11px;
  margin-left: 5px;
  width: 12px;
  height: 13px;
}
/*swipe*/
.dis_imga{
  width: 100%!important;
  height: auto;
}
.dis_a{
  height: 166px;
  width: 100%;
}
.mint-swipe-indicators{
  bottom:18px;
}
</style>



// WEBPACK FOOTER //
// src/components/shouye/index.vue